<template>
  <v-card class="px-0 mb-2">
    <v-toolbar color="primary background--text">
      <v-toolbar-title>{{$t('screener.player.playlist.card.title')}}</v-toolbar-title>
    </v-toolbar>

    <FilmList :currentIndex="currentIndex" :screener="screener" :showTrailerBtn="false"></FilmList>

  </v-card>
</template>
<script>
import FilmList from "@/components/screener/FilmList";
export default {
    props: {
    screener: {
      type: Object,
      default: null
    },
    currentIndex: {
      type: Number,
      default: null
    }
  },
  name: "FilmPlaylist",
  components: {
      FilmList
  }
};
</script>
<style lang="stylus" scoped>
.scroll {
   overflow-y: scroll
}
</style>
